<template>
  <avatar-header :avatar="coach && coach.avatar" :title="`您的私人教练：${coach && coach.name}`" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AvatarHeader from '@/components/AvatarHeader';

const { mapState } = createNamespacedHelpers('coach');

export default {
    computed: {
        ...mapState([
            'coach',
        ]),
    },
    components: {
        AvatarHeader,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/CoachHeader.vue